/* eslint-disable no-debugger */
import { API_NAMES, initApi } from '@usas/ui-web/utils/HttpApiHelper';
import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

const getOfficialCompetitionCategoryData = (personId, state, setState) => {
  const api = initApi(API_NAMES.PERSON, state, setState);

  const personIdForUrl = personId ? encodeURIComponent(personId) : 0;
  const url = `/Person/personOfficialCompetitionCategory/${personIdForUrl}`;
  return api?.executeObject ? api.executeObject(url, 'GET') : null;
};

const putOfficialCompetitionCategoryData = (personId, officialCompetitionCategoryObj, state, setState) => {
  if (personId.length > 0 && officialCompetitionCategoryObj) {
    const api = initApi(API_NAMES.PERSON, state, setState);
    const personIdForUrl = personId ? encodeURIComponent(personId) : 'NaN';
    const url = `/Person/personOfficialCompetitionCategoryChange/${personIdForUrl}`;

    return api?.executeObject ? api.executeObject(url, 'PUT', officialCompetitionCategoryObj) : null;
  }
};

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const OfficialCompetitionCategoryData = {
  INITIAL_STATE: { ...INITIAL_STATE },
  getOfficialCompetitionCategoryData,
  putOfficialCompetitionCategoryData
};

export default OfficialCompetitionCategoryData;